import React from 'react';
import ReactDOM from 'react-dom/client';
import { WagmiProvider } from 'wagmi';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RainbowKitProvider, type AvatarComponent } from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';

import App from './App';
import './index.css';
import { config, humanityTestnet } from './config/wagmi';
import { customTheme } from './config/rainbowkit-theme';
import humanityIcon from './assets/humanity-icon.svg';

const queryClient = new QueryClient();

/**
 * Custom avatar component using Humanity Protocol logo
 * Replaces the default avatar in both ConnectButton and AccountModal
 *
 * @param size - Avatar size (provided by RainbowKit)
 * @param address - Wallet address (provided by RainbowKit)
 * @param ensImage - ENS avatar image if available (provided by RainbowKit)
 */
const CustomAvatar: AvatarComponent = ({ size }) => {
  return (
    <img
      src={humanityIcon}
      alt="Humanity Protocol"
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'contain',
        background: 'rgba(255, 255, 255, 0.1)',
        padding: '4px',
      }}
    />
  );
};

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider
          theme={customTheme}
          initialChain={humanityTestnet}
          avatar={CustomAvatar}
        >
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  </React.StrictMode>
);
